import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const FsNextArrowIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      width="19"
      height="13"
      viewBox="0 0 19 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6638 0.292893C11.0543 -0.0976311 11.6874 -0.0976311 12.078 0.292893L18.2851 6.5L12.078 12.7071C11.6874 13.0976 11.0543 13.0976 10.6638 12.7071C10.2732 12.3166 10.2732 11.6834 10.6638 11.2929L14.4566 7.5L1 7.5C0.447715 7.5 0 7.05228 0 6.5C5.96046e-08 5.94771 0.447715 5.5 1 5.5L14.4567 5.5L10.6638 1.70711C10.2732 1.31658 10.2732 0.683417 10.6638 0.292893Z"
      />
    </SvgIcon>
  );
};

export default FsNextArrowIcon;
